"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.promise");

var _config = require("../config");

var _utils = _interopRequireDefault(require("../utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setLocal = _utils.default.setLocal,
    getLocal = _utils.default.getLocal,
    clearLocal = _utils.default.clearLocal,
    setUrlParams = _utils.default.setUrlParams,
    urlParams = _utils.default.urlParams,
    isWX = _utils.default.isWX,
    getENV = _utils.default.getENV,
    xhr = _utils.default.xhr;
/**
 * 获取openId
 * 入参：
 *  {String} ：公众号授权地址
 *  {Number} ：openid有效期
 *  {String} ：code获取openid api
 */

function getOpenId() {
  var authUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config.WECHAT.auth.url;
  var diff = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config.WECHAT.auth.diff;
  var api = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "".concat(_config.WECHAT.auth.host[getENV()]).concat(_config.WECHAT.auth.path);
  var appId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _config.WECHAT.appId;
  return new Promise(function (resolve, reject) {
    var openId = getLocal('hcb_wx_openId');
    var code = urlParams.code;
    var url = setUrlParams(authUrl, {
      redirect_uri: encodeURIComponent(window.location.href),
      appid: appId
    });

    if (!openId) {
      if (!code) {
        // 如果localstorage中没有openId，url中也没有code，重新授权
        window.location.replace(url);
      } else if (!isWX) {
        window.location.replace(url);
      } else {
        // 如果localstorage中没有openId，url有code，则根据code通过接口获取openId
        xhr(api, {
          code: code
        }, 'GET').then(function (resp) {
          openId = resp.content;

          if (openId) {
            setLocal('hcb_wx_openId', openId);
            setLocal('hcb_wx_openId_time', Date.now());
            resolve(openId);
          } else {
            reject();
          }
        }, reject);
      }
    } else {
      // 如果localstorage中有openId，判断有效期，过期重新授权，有效直接返回
      var time = getLocal('hcb_wx_openId_time');
      var time1 = Date.now();

      if (time1 - time > diff) {
        clearLocal('hcb_wx_openId', '');
        window.location.replace(url);
      } else {
        resolve(openId);
      }
    }
  });
}

var _default = {
  getOpenId: getOpenId
};
exports.default = _default;